<template>
  <div>
    <div class="row">
      <div class="col-4">
        <app-info :appInfo="appInfo" :no-refresh="true" v-on:refreshData="refreshAppData"></app-info>
      </div>
      <div class="col-3">
        <db-info :dbInfo="dbInfo" :no-refresh="true" v-on:refreshData="refreshDbData"></db-info>
      </div>
    </div>
  </div>
</template>
<script>
import AppInfo from "../../components/Beast/SystemInfo/AppInfo.vue";
import DbInfo from "../../components/Beast/SystemInfo/DbInfo.vue";

export default {
  components: {
    AppInfo, DbInfo
  },
  data() {
    return {
      appInfo: {
        appName: "",
        version: "",
        environment: "",
        framework: "",
        frameworkVersion: ""
      },
      dbInfo: {
        environment: "",
        dbHost: "",
        dbType: "",
        dbDatabase: ""
      }
    };
  },
  methods: {
    async refreshAppData() {
      const response = await this.axios.get("/sysinfo/about");
      this.appInfo = response.data;
    },
    async refreshDbData() {
      const response = await this.axios.get("/sysinfo/db");
      this.dbInfo = response.data;
    }
  },
  beforeMount() {
    this.refreshAppData();
    this.refreshDbData();
  }
};
</script>
<style>

</style>
